import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";

const PARTNERS = [
  { id: "edutainment", name: "The Edutainment Box — Arkweaver TFX", logo: "/assets/logo-edutainment.png" },
  { id: "dabo", name: "DABO Detroit", logo: "/assets/logo-dabo.png" },
  { id: "medxai", name: "MedX AI", logo: "/assets/logo-medxai.png" },
];

const Sponsors = () => (
  <section id="partners" data-testid="sponsors-section" className="relative py-20 sm:py-24 border-t border-white/10">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="text-center">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand-400">Sponsors & Event Partners</p>
      </Reveal>
      <div className="mt-10 grid gap-4 sm:grid-cols-3">
        {PARTNERS.map((p, i) => (
          <motion.div
            key={p.id}
            data-testid={`sponsor-logo-${p.id}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ y: -6, transition: { type: "spring", stiffness: 300, damping: 20 } }}
            className="group flex h-44 sm:h-52 items-center justify-center rounded-2xl border border-white/10 bg-charcoal/60 p-6 transition-colors duration-500 hover:border-brand-500/40"
            title={p.name}
          >
            <img
              src={p.logo}
              alt={p.name}
              className="max-h-full w-auto max-w-full object-contain mix-blend-screen transition-transform duration-500 group-hover:scale-105"
            />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Sponsors;
